import { NavigationExtras } from '@angular/router';

export const preserveQueryParams = (): Partial<NavigationExtras> => ({
  queryParamsHandling: 'preserve'
});
